import { publicLanguage, sessionLanguage } from "../config";
import { RTL_LOCALES } from "../modules/constants";
import i18n from "i18next";
import moment from "moment";
import { registerLocale, setDefaultLocale } from "react-datepicker";

export const DEFAULT_LOCALE = "en-US";
export const DEFAULT_MOMENT_LOCALE = "en";

export const convertLocale = (locale) => {
  if (locale?.length === 2) {
    return `${locale}_${locale.toUpperCase()}`;
  }

  return locale.replace("-", "_");
};

export const getCurrentLocale = () => {
  return sessionStorage.getItem(sessionLanguage) || DEFAULT_LOCALE;
};

export const getPublicLocale = () => {
  return DEFAULT_LOCALE;
};

export const availableLanguages = process?.env?.REACT_APP_AVAILABLE_LANGUAGES;
export const checkLanguageAvailability = (code) => {
  if (
    !availableLanguages ||
    availableLanguages === "all" ||
    availableLanguages === ""
  ) {
    return true;
  }

  return availableLanguages.split(",").includes(code);
};

export const getLanguages = () => [
  {
    id: "ar-sa",
    code: "ar-SA",
    value: "Arabic (Saudi Arabia)",
    translationId: "appText.language.arabic.saudiArabia",
    isAvailable: checkLanguageAvailability("ar-sa"),
  },
  {
    id: "cs",
    code: "cs",
    value: "Czech",
    translationId: "appText.language.czech",
    isAvailable: checkLanguageAvailability("cs"),
  },
  {
    id: "en-us",
    code: "en-US",
    value: "English",
    translationId: "appText.language.english",
    isAvailable: checkLanguageAvailability("en-US"),
  },
  {
    id: "pl",
    code: "pl",
    value: "Polish",
    translationId: "appText.language.polish",
    isAvailable: checkLanguageAvailability("pl"),
  },
  {
    id: "es",
    code: "es",
    value: "Spanish",
    translationId: "appText.language.spanish",
    isAvailable: checkLanguageAvailability("es"),
  },
  {
    id: "tr",
    code: "tr",
    value: "Turkish",
    translationId: "appText.language.turkish",
    isAvailable: checkLanguageAvailability("tr"),
  },
  {
    id: "de",
    code: "de",
    value: "German",
    translationId: "appText.language.german",
    isAvailable: checkLanguageAvailability("de"),
  },
  {
    id: "ja",
    code: "ja",
    value: "Japanese",
    translationId: "appText.language.japanese",
    isAvailable: checkLanguageAvailability("ja"),
  },
];

export const isRtl = () => {
  const locale = getCurrentLocale();
  return RTL_LOCALES.find((lang) => lang === locale);
};

export const isJapanese = () => {
  const locale = getCurrentLocale();

  return locale === "ja";
};

export const refreshAppLanguage = () => {
  const locale = getCurrentLocale();
  i18n.changeLanguage(locale);

  if (locale !== DEFAULT_LOCALE) {
    import(`moment/locale/${locale.toLowerCase()}`).then(() => {
      moment.locale(locale.toLowerCase());
    });

    import(`date-fns/locale/${locale}/index.js`).then((data) => {
      const importedLocale = data.default;
      registerLocale(`${locale}`, {
        ...importedLocale,
        options: {
          weekStartsOn:
            locale === "ja" ? 1 : importedLocale?.options?.weekStartsOn,
          firstWeekContainsDate: 1,
        },
      });
      setDefaultLocale(`${locale}`);
    });
  } else {
    moment.locale(locale.toLowerCase());
    setDefaultLocale(DEFAULT_LOCALE);
  }

  const htmlElement = document.getElementsByTagName("html")[0];
  const htmlDirAttribute = htmlElement.getAttribute("dir");
  const linkWithBootstrap = document.getElementById("style-direction");

  if (isRtl()) {
    if (!htmlDirAttribute) {
      htmlElement.setAttribute("dir", "rtl");
      linkWithBootstrap.setAttribute("href", "/css/bootstrap.rtl.min.css");
    }
  } else {
    if (htmlDirAttribute) {
      htmlElement.removeAttribute("dir");
      linkWithBootstrap.setAttribute("href", "/css/bootstrap.min.css");
    }
  }
};

export const getLanguageName = (languageCode) => {
  return (
    getLanguages().find((lang) => lang.code === languageCode).translationId ||
    ""
  );
};
